import authRoles from "core/auth/authRoles";
import { lazy } from "react";
const IssuanceProcess = lazy(() => import("./IssuanceProcess"));

const issuanceProcessConfig = {
  component: IssuanceProcess,
  path: "/issuance-process",
  exact: true,
  layout: {
    config: {
      navbar: {
        display: true,
      },
      sidebar: {
        display: true,
      },
      midbar: {
        display: false,
      },
      footer: {
        display: false,
      },
    },
  },
  auth: authRoles.organization,
  protected: true,
};

export default issuanceProcessConfig;
